module.exports = "/public/webpack/img/icon_help_all_246c454d3e0c22e5021ea9f5d6726339d6.png";